import { useBreakpoints } from '@vueuse/core';
import { computed } from 'vue';

export function useDevice() {
  const breakpoints = useBreakpoints({
    mobile: 0,
    tablet: 768,
    desktop: 1024,
  });

  const isMobile = computed(() => breakpoints.smaller('tablet').value);
  const isTablet = computed(
    () => breakpoints.between('tablet', 'desktop').value,
  );
  const isDesktop = computed(() => breakpoints.greater('desktop').value);

  return {
    isMobile,
    isTablet,
    isDesktop,
  };
}
